import LocationDistance from "./LocationDistance";

export default LocationDistance;